import React, { forwardRef } from 'react';
import { Input } from 'antd';
import { Button } from 'appkit-react';

export const EditableCell = forwardRef((props, ref) => {
  const {
    isEditing = false,
    value,
    defaultValue,
    addClassName,
    onInput = () => {},
    style,
    maxLength,
  } = props;
  const defaultValueOfInput = defaultValue === '-' ? '' : defaultValue;
  return isEditing ? (
    <Input
      defaultValue={defaultValueOfInput}
      className={addClassName}
      ref={ref}
      onInput={onInput}
      style={style}
      maxLength={maxLength}
    />
  ) : (
    value
  );
});

export const Save = ({ actionHandler, isLoading }) => (
  <Button
    size="sm"
    kind="primary"
    onMouseDown={actionHandler}
    isLoading={isLoading}
    className="save-btn"
  >
    save
  </Button>
);
